import type { ConversationSummary } from '@tabbio/types';

/**
 * A conversation becomes inbox-visible only after its first persisted message.
 * `lastMessageAt` is not authoritative because legacy draft rows populated it
 * at creation time even though no message existed.
 */
export function isInboxConversation(
  conversation: ConversationSummary,
): boolean {
  return conversation.lastMessage != null;
}
